import { AxiosResponse } from 'axios'
import { sumBy } from 'lodash-es'
import {
    OrderPaymentStatus,
    OrderStatus,
    ProcessPaymentContract,
    SaleSlimModel,
} from 'models'
import pendingOrderDbService from 'utilities/offlineDb/pendingOrderDbService'
import { v4 } from 'uuid'

export const processOfflinePayment = async (
    payload: ProcessPaymentContract,
): Promise<AxiosResponse<SaleSlimModel>> => {
    const pendingTransaction = await pendingOrderDbService.getById(
        payload.orderID!,
    )
    if (!pendingTransaction)
        throw new Error('not found order ' + payload.orderID)

    const previousPayments = pendingTransaction.payments ?? []
    const remainingDueAmount =
        pendingTransaction.order.totalDueAmount! -
        previousPayments.reduce(
            (acc, p) =>
                acc +
                (p.payments?.[0]?.tenderedAmount! -
                    p.payments?.[0]?.changeAmount!),
            0,
        )
    const currentPaymentPaidAmount =
        payload.payments?.[0]?.tenderedAmount! -
        payload.payments?.[0]?.changeAmount!
    let paymentStatus: OrderPaymentStatus = OrderPaymentStatus.Paid

    if (currentPaymentPaidAmount < remainingDueAmount)
        paymentStatus = OrderPaymentStatus.PartiallyPaid

    await pendingOrderDbService.savePayment(payload)

    const response: SaleSlimModel = {
        saleNo: 'xyzzy',
        paymentStatus: paymentStatus,
        orderID: payload.orderID,
        subtotal: sumBy(payload.payments ?? [], (a) => a.expectAmount ?? 0),
        tenderedAmount: sumBy(
            payload.payments ?? [],
            (a) => a.tenderedAmount ?? 0,
        ),
        changeAmount: sumBy(payload.payments ?? [], (a) => a.changeAmount ?? 0),
        order: {
            orderPaymentStatus: paymentStatus,
            status:
                paymentStatus === OrderPaymentStatus.Paid
                    ? OrderStatus.Completed
                    : OrderStatus.Saved,
        },
        payments:
            payload.payments?.map((p) => ({
                // use random ID as if it saved/processed in online mode.
                paymentID: v4(),
                paymentTypeID: p.paymentTypeID,
                amount: p.tenderedAmount,
            })) ?? [],
    }

    const axiosResponse: AxiosResponse<SaleSlimModel> = {
        data: response,
        status: 200,
        statusText: 'OK',
        headers: {},
        config: {},
    }

    return Promise.resolve(axiosResponse)
}
